import { isObject } from "lodash";
import SocketWorker from "./SocketWorker";

export function socketConnection(params) {
  let user_id = "";
  let company_id = "";
  if (isObject(params)) {
    company_id = params?.user?.companyId || params?.user?.company_id || params?.companyId || params?.company_id;
    user_id = params?.user?.id || params?.user?.userId || params?.userId || params?.id;
  }

  if (!company_id || !user_id) {
    return {
      on: () => {},
      off: () => {},
      emit: () => {},
      disconnect: () => {},
      connect: () => {}
    };
  }

  return SocketWorker(company_id, user_id);
}
